import { TextButton } from "../../ui/input/TextButton";
import { ComponentF, createElement } from "../../ui/ui";

const LEVELS = ["Loud", "Soft", "Mute"];

export const AudioToggle: ComponentF<{
  title: string;
  keys: string | string[];
  onClick: () => void;
}> = (C) => {
  const [state, setState] = C.useState({ level: 0 });
  return [
    createElement(
      TextButton,
      { x: 0, y: 0, w: C.bounds.w, h: 1 },
      {
        keys: "F1",
        title: LEVELS[state.level],
        keyLabel: "F1",
        onClick: () => {
          const next = (state.level + 1) % 3;
          setState({ level: next });
          switch (next) {
            case 0:
              Howler.volume(1.0);
              Howler.mute(false);
              break;
            case 1:
              Howler.volume(0.5);
              Howler.mute(false);
              break;
            case 2:
              Howler.mute(true);
              break;
          }
        },
      }
    ),
  ];
};
